<template>
  <div class="detail-box">
    <div class="title">【{{ cardName }}】添加白名单</div>
    <el-form ref="form" :model="form" :rules="rules" label-width="160px">
      <el-form-item label="白名单手机号：" prop="mobile">
        <el-input v-model.trim="form.mobile" maxlength="20" clearable placeholder="请输入" style="width: 320px" />
      </el-form-item>
      <el-form-item label="姓名：">
        <el-input v-model.trim="form.name" maxlength="50" clearable placeholder="请输入" style="width: 320px" />
      </el-form-item>
      <el-form-item label="开通时间：">
        <el-radio-group v-model="form.beginType">
          <el-radio :label="0">立即开通</el-radio>
          <el-radio :label="1">指定时间</el-radio>
        </el-radio-group>
        <el-date-picker
          v-if="form.beginType === 1"
          v-model="form.beginTime"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择时间"
          style="margin-left: 12px"
        />
      </el-form-item>
      <el-form-item label="到期时间：">
        <el-radio-group v-model="form.endType">
          <el-radio :label="0">跟随卡片期限</el-radio>
          <el-radio :label="1">指定时间</el-radio>
        </el-radio-group>
        <el-date-picker
          v-if="form.endType === 1"
          v-model="form.endTime"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择时间"
          style="margin-left: 12px"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="saving" @click="submit">新增</el-button>
        <el-button @click="$router.back()">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "rightsCardWhitelistAdd",
  data() {
    return {
      saving: false,
      form: {
        mobile: "",
        name: "",
        beginType: 0,
        beginTime: null,
        endType: 0,
        endTime: null,
      },
      rules: {
        mobile: [{ required: true, message: "请输入手机号", trigger: "blur" }],
      },
    };
  },
  computed: {
    cardId() {
      return this.$route.query.cardId;
    },
    cardName() {
      return this.$route.query.cardName || "权益卡";
    },
  },
  methods: {
    submit() {
      this.$refs.form.validate(async (ok) => {
        if (!ok) return;
        if (this.form.beginType === 1 && !this.form.beginTime) {
          this.$message.warning("请选择开通时间");
          return;
        }
        if (this.form.endType === 1 && !this.form.endTime) {
          this.$message.warning("请选择到期时间");
          return;
        }
        this.saving = true;
        try {
          const res = await this.axios.post(
            this.getApiUrl("rightsCardWhitelistCreate"),
            {
              cardId: Number(this.cardId),
              mobile: this.form.mobile,
              name: this.form.name,
              beginType: this.form.beginType,
              beginTime: this.form.beginType === 1 ? this.form.beginTime : null,
              endType: this.form.endType,
              endTime: this.form.endType === 1 ? this.form.endTime : null,
            },
            { toJSON: true }
          );
          if (res && res.code === 1) {
            this.$message.success("新增成功");
            this.$router.push({
              name: "rightsCardWhitelist",
              query: { cardId: this.cardId, cardName: this.cardName },
            });
          } else {
            this.$message.error((res && res.msg) || "新增失败");
          }
        } finally {
          this.saving = false;
        }
      });
    },
  },
};
</script>

<style scoped>
.detail-box {
  padding: 20px 24px;
}
.title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 20px;
}
</style>
